import { forwardRef } from 'react';

import { cn } from './cn.js';

import type { SelectHTMLAttributes } from 'react';

interface GlassSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string | undefined;
  options: readonly { value: string; label: string }[];
  placeholder?: string;
}

export const GlassSelect = forwardRef<HTMLSelectElement, GlassSelectProps>(
  ({ label, error, options, placeholder, className, id, ...props }, ref) => {
    const selectId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="flex flex-col gap-1.5">
        {label !== undefined && label !== '' && (
          <label htmlFor={selectId} className="text-sm font-medium text-text-secondary">
            {label}
          </label>
        )}
        <select
          ref={ref}
          id={selectId}
          className={cn(
            'h-9 px-3 rounded-lg text-text text-sm',
            'bg-[var(--glass-bg)] border border-[var(--glass-border)]',
            'backdrop-blur-[var(--glass-blur-subtle)]',
            'transition-all duration-[var(--dur)] ease-[var(--ease)]',
            'hover:bg-[var(--glass-bg-hover)] hover:border-[var(--glass-border)]',
            'focus:outline-none focus:ring-2 focus:ring-ring focus:border-primary',
            'focus:shadow-[var(--glass-glow)]',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            error !== undefined && error !== '' && 'border-danger focus:ring-danger/30',
            className,
          )}
          {...props}
        >
          {placeholder !== undefined && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {error !== undefined && error !== '' && <p className="text-xs text-danger">{error}</p>}
      </div>
    );
  },
);
